const firebaseConfig = {
    apiKey: "AIzaSyA90F53QL4LMMnxk5-9TFTr7PZThmUjjAI",
    authDomain: "leticia-ensino-fundamental.firebaseapp.com",
    projectId: "leticia-ensino-fundamental",
    storageBucket: "leticia-ensino-fundamental.appspot.com",
    messagingSenderId: "157914920976",
    appId: "1:157914920976:web:ea008edd2e907958347295"
};  

const firebaseConfigAvisos = {
    apiKey: "AIzaSyBf8RjwbSylZp_BwDNUF1M97b4rShb7oQs",
    authDomain: "avisos-leticia.firebaseapp.com",
    projectId: "avisos-leticia",
    storageBucket: "avisos-leticia.appspot.com",
    messagingSenderId: "1064096034909",
    appId: "1:1064096034909:web:1a85e559fd46ac81a55db4"  
};

const firebaseConfigFormularios = {
    apiKey: "AIzaSyBwhSLGBcQEFJw1BYfIVG_VcVxzdmAwk1M",
    authDomain: "formularios-c458a.firebaseapp.com",
    projectId: "formularios-c458a",
    storageBucket: "formularios-c458a.appspot.com",
    messagingSenderId: "1075545337388",
    appId: "1:1075545337388:web:24185661999e1180c2ab89"  
};

const firebaseConfigCalendario = {
    apiKey: "AIzaSyAtsgFme61j70yqVRvxy876j1-8kb6u7vk",
    authDomain: "calendario-leticia.firebaseapp.com",
    projectId: "calendario-leticia",
    storageBucket: "calendario-leticia.appspot.com",
    messagingSenderId: "62794935391",
    appId: "1:62794935391:web:fc1ab9333b2961fb357fea"
};  
  
export { firebaseConfig, firebaseConfigFormularios, firebaseConfigAvisos, firebaseConfigCalendario };